<template>
  <div v-if="hasPermission(permissions.featuresCreate)">
    <content-header>{{ $t('createFeature') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <number-input id="extraPrice" :name="$t('extraPrice')" :validate="$v" :required="true" :is-loading="isLoading" />
            <submit-input :name="$t('create')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {Feature} from "@/models/Feature";
import SubmitInput from "@/components/Inputs/SubmitInput";
import TextInput from "@/components/Inputs/TextInput";
import NumberInput from "@/components/Inputs/NumberInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "FeatureCreate",
  components: {NumberInput, TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new Feature().fillAbles),
      isLoading: false,
      selectedItem: {},
      permissions: permissions
    }
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
      extraPrice: {required},
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('features/CREATE', this.form).then(() => {
        this.$v.$reset();
        this.$router.push({name: "features"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
